<template>
  <div class="mt-1">
    <div class="card" @click="viewDetail(route)" style="cursor: pointer">
      <div class="card-body">
        <div class="row">
          <h5 class="mx-auto" style="font-size: 12px">
            {{humanDate(route.created_at)}}
          </h5>
        </div>
        <div class="row">
          <div class="col-2">
            <img
              v-if="route.children.url_image != null"
              :src="route.children.url_image"
              class="img-fluid rounded-circle"
              style="max-width: 50px; max-height: 50px"
              alt="Imagen de la ruta"
            />
          </div>
          <div class="col-7">
            <p class="card-text" style="font-size: 12px">
              {{ route.children.full_name }}
            </p>
            <p style="font-size: 12px">
              Frec:

              <span v-if="route.route.frecuency_day_1 == 1">L</span>
              <span v-if="route.route.frecuency_day_2 == 1">M</span>
              <span v-if="route.route.frecuency_day_3 == 1">M</span>
              <span v-if="route.route.frecuency_day_4 == 1">J</span>
              <span v-if="route.route.frecuency_day_5 == 1">V</span>
              <span v-if="route.route.frecuency_day_6 == 1">S</span>
              <span v-if="route.route.frecuency_day_7 == 1">D</span>
            </p>
          </div>
          <div class="col-3">
            <p class="card-text" style="font-size: 12px">
              <i class="fas fa-undo"></i> <strong>{{route.type_route.name}}</strong>
            </p>
          </div>
        </div>
        <hr />
        <div class="row mb-2">
          <div class="col-2"></div>
          <div class="col-10">
            <p style="font-size: 12px" class="card-text">
              <v-icon name="map-marker-alt" fill="red"></v-icon> <strong>Desde:</strong> {{ route.route.current_location.name }}
            </p>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2"></div>
          <div class="col-10">
            <p style="font-size: 12px" class="card-text">
              <v-icon name="map-marker-alt" fill="blue"></v-icon> <strong>Hasta:</strong> {{ route.route.location.name }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <i class="fas fa-users mr-3"></i>
            <p style="font-size: 12px" class="card-text">
              <strong>Ruta:</strong> {{ route.service_code }}
              <strong>Estado:</strong> {{ route.status_service.name }}
            </p>
          </div>
        </div>
        <hr />
        <div class="row pb-3">
          <div class="col-2">
            <img
              :src="route.driver.url_image"
              class="img-fluid rounded-circle"
              style="max-width: 40px; max-height: 40px"
              alt="Imagen de la ruta"
            />
          </div>
          <div class="col-6">
            <p
              style="line-height: 15px !important; font-size: 12px"
              class="card-text"
            >
              <strong> {{ route.driver.full_name }}</strong
              ><br />Conductora
            </p>
          </div>

          <div class="col-3 text-right">
            <!-- <button type="button" class="btn btn-success">
              <i class="fas fa-check"></i> Calificar
            </button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'RouteCard',
  props: {
    route: {
      type: Object
    }
  },
  methods: {
    humanDate(date) {
      //Format in legible date
      moment.locale('es')
      return moment(date).format('dddd DD [de] MMMM [de] YYYY')
    },
    viewDetail(route) {
      console.log(route)
      this.$router.push({ name: 'ServiceDetail', params: { id: route.id } })
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 1rem;
  transition: transform 0.2s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
